// Types
import type { TransTextRegexes, TransTextComponent } from '@/types/utils/trans-text'

const TransText = (str: string) => {
	// Variables
	let finalDescription: string = str || ''
	const components: TransTextComponent[] = []
	let hasPattern: boolean = false

	// Set attributes
	finalDescription = finalDescription
		.replaceAll('class=', 'className=')
		.replaceAll('&lt;table&gt;', '<table>')
		.replaceAll('&lt;/table&gt;', '</table>')
		.replaceAll('&lt;thead&gt;', '<thead>')
		.replaceAll('&lt;/thead&gt;', '</thead>')
		.replaceAll('&lt;tbody&gt;', '<tbody>')
		.replaceAll('&lt;/tbody&gt;', '</tbody>')
		.replaceAll('&lt;tr&gt;', '<tr>')
		.replaceAll('&lt;/tr&gt;', '</tr>')
		.replaceAll('&lt;th&gt;', '<th>')
		.replaceAll('&lt;/th&gt;', '</th>')
		.replaceAll('&lt;td&gt;', '<td>')
		.replaceAll('&lt;/td&gt;', '</td>')
		.replaceAll('&lt;icon&gt;', '<icon>')
		.replaceAll('&lt;/icon&gt;', '</icon>')
		.replaceAll('&lt;alert&gt;', '<alert>')
		.replaceAll('&lt;/alert&gt;', '</alert>')
		.replaceAll('&lt;item&gt;', '<item>')
		.replaceAll('&lt;/item&gt;', '</item>')
		.replaceAll('&amp;', '&')
		.replaceAll('&nbsp;', ' ')

	// Convert <video> tags containing Vimeo/YouTube embed URLs to <iframe> embeds
	// Also strip surrounding <p> tags if present to avoid hydration errors (<div> inside <p> is invalid)
	finalDescription = finalDescription.replace(
		/(?:<p[^>]*>\s*)?<video[^>]*>[\s\S]*?<source\s+src="(https?:\/\/(?:player\.vimeo\.com\/video|www\.youtube\.com\/embed)\/[^"]+)"[^>]*>[\s\S]*?<\/video>(?:\s*<\/p>)?/gi,
		(_match, url) => {
			return `<div className="editor-video-embed"><iframe src="${url}" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture" allowFullScreen></iframe></div>`
		}
	)


	// Check
	const checkRegexes: TransTextRegexes = {
		' ': new RegExp(' style="[^"]+"', 'g'),
		'<gallery>': new RegExp('<p[^>]+><span[^>]+>&lt;gallery&gt;</span></p>', 'g'),
		'</gallery>': new RegExp('<p[^>]+><span[^>]+>&lt;/gallery&gt;</span></p>', 'g')
	}

	Object.keys(checkRegexes).map(key => {
		const regex = checkRegexes[key]

		if (regex.test(finalDescription)) {
			const result = finalDescription.match(regex)

			if (result && result.length > 0)
				result.map(item => {
					finalDescription = finalDescription.replaceAll(item, key)
				})
		}
	})

	// Remove extra span
	finalDescription = finalDescription
		.replaceAll(/<p [^>]+><span ><table><\/span><br>/g, '<grid><table>')
		.replaceAll('<span ></table></span></p>', '</table></grid>')
		.replaceAll('<span ><thead></span><br>', '<thead>')
		.replaceAll('<span ></thead></span><br>', '</thead>')
		.replaceAll('<span ><tbody></span><br>', '<tbody>')
		.replaceAll('<span ></tbody></span><br>', '</tbody>')
		.replaceAll('<span ><tr></span><br>', '<tr>')
		.replaceAll('<span ></tr></span><br>', '</tr>')
		.replaceAll('<span ><th>', '<th>')
		.replaceAll('</th></span><br>', '</th>')
		.replaceAll('<span ><td>', '<td>')
		.replaceAll('</td></span><br>', '</td>')

	// Find
	const findRegexes: TransTextRegexes = {
		gallery: new RegExp('<gallery>(.*?)(?=</gallery>)', 'g')
	}

	Object.keys(findRegexes).map(key => {
		const regex = findRegexes[key]

		if (regex.test(finalDescription)) {
			let result = finalDescription.match(regex)

			if (result && result.length > 0)
				result.map(item => {
					finalDescription = finalDescription.replace(item, '')
					components.push({ type: key, description: item.replace(`<${key}>`, '') })

					if (key === 'pattern') hasPattern = true
				})
		}
	})

	// Remove extra div
	finalDescription = finalDescription.replaceAll('</gallery>', '')

	return { text: finalDescription, components, hasPattern }
}

export default TransText
